import { CrmAppConfiguration } from 'common-module/core/types';

import { environment } from '~/envs/environment';

export const appConfig: CrmAppConfiguration = { environment };
